import { CREATE_INSTANCE, SET_TEST_DATA, SET_VIDEO_ID, RETRY, FIRST_TIME_INIT, ERROR_MESSAGE } from "../actions/livenessTest";

const defaultState = {
  livenessTestData: undefined,
  livenessVideoId: undefined,
  retriesLeft: 0,
  videoId: undefined,
  firstTimeInitialized: false,
  errorMessage: ""
}

export function livenessTest(state = defaultState, action) {
  switch (action.type) {
    case CREATE_INSTANCE:
      return {
        ...state,
        CLRCaptureInstance: action.payload
      }
    case SET_TEST_DATA:
      return {
        ...state,
        livenessTestData: action.payload,
        retriesLeft: action.payload.items[0].maxRetries
      }
    case SET_VIDEO_ID:
      return {
        ...state,
        videoId: action.payload
      }
    case RETRY:
      return {
        ...state,
        retriesLeft: state.retriesLeft - 1
      }
    case FIRST_TIME_INIT:
      return {
        ...state,
        firstTimeInitialized: true
      }
    case ERROR_MESSAGE:
      return {
        ...state,
        errorMessage: action.payload
      }
    default:
      return state;
  }
}

